import resourceConfig from '../config';

export default {
    resources: {
        [resourceConfig.name]: {
            name: 'Отчет |||| Отчеты',
            title: 'Данные по КМ из ГИС МТ',
            openAction: 'Открыть',
            executeAction: 'Отправить',
            executeActionUit: 'Отправить',
            successMessage: 'Запрос успешно отправлен',
            errorMessage: 'Ошибка при отправке запроса',
            sectionFile: 'Загрузка файла и адреса',
            sectionUit: 'Поиск по коду маркировки',
            fields: {
                file: 'Файл (.xlsx)',
                addresses: 'Адреса',
                address: 'Адрес',
                uitCode: 'Код маркировки',
            },
        }
    }
};
